const AppFooter = () => {
  return (
    <div className="layout-footer">
      <div className="footer-logo-container pt-2">
        cocharge - power the people.
      </div>
      <span className="footer-copyright">
        &#169; cocharge - {new Date().getFullYear()}
      </span>
    </div>
  );
};

export default AppFooter;
